import isNil from 'lodash/isNil';
export function toRecursiveOptionValue(dataAccess, isRecursive) {
    if (isNil(dataAccess)) {
        return undefined;
    }
    return isRecursive ? 1 : 0;
}
export function fromRecursiveOptionValue(value) {
    return value === 1;
}
